import { GET_COMPANY } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import type { ICompanyAppMapping } from "@models";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { normalizeCompanyAppsMapping } from "./companyAppsMappingUtils";

export {
  buildApplicationMappingSelectOptions,
  formatCompanyAppMappingLabel,
  type ICompanyApplicationMappingOption,
  normalizeCompanyAppsMapping,
} from "./companyAppsMappingUtils";

export const COMPANY_APPS_MAPPING_KEY = "companyAppsMappingKey";

export const getCompanyAppsMappingKey = (
  companyUuid: string,
  basePath?: string,
) => [COMPANY_APPS_MAPPING_KEY, companyUuid, basePath] as const;

export const useCompanyAppsMapping = (
  companyUuid: string | undefined,
  basePath?: string,
  options?: Partial<
    UseQueryOptions<
      ICompanyAppMapping[],
      AxiosError,
      ICompanyAppMapping[],
      ReturnType<typeof getCompanyAppsMappingKey>
    >
  >,
) => {
  return useQuery({
    queryKey: getCompanyAppsMappingKey(companyUuid ?? "", basePath),
    queryFn: async () => {
      const path = `${GET_COMPANY}/${companyUuid}/company-apps-mapping`;
      const url = basePath ? `${basePath.replace(/\/$/, "")}${path}` : path;
      const data = await mutationFetch<unknown>({ url, method: "GET" });
      return normalizeCompanyAppsMapping(data);
    },
    enabled: !!companyUuid,
    ...options,
  });
};
